export function getCurrentDate() {
  const newDate = new Date();
  const currentDateISO = newDate.toISOString();
  const currentDate = currentDateISO.split('T')[0];

  return currentDate;
}

export function getDaysBetween(dateFirst, dateNext) {
  const date1 = new Date(dateFirst);
  const date2 = new Date(dateNext);
  const difference = date2.getTime() - date1.getTime();
  const daysBetween = Math.ceil(difference / (1000 * 3600 * 24));

  return daysBetween;
}
